"use client";
import cn from "classnames";
import { type SocialIconType } from "@/constants/media";
import type { HTMLAttributes } from "react";
import s from "./SocialIcon.module.scss";
import { getSocialIconByType } from "./utils";

interface SocialIconProps
  extends Pick<HTMLAttributes<HTMLElement>, "className"> {
  icon: SocialIconType;
}

export default function SocialIcon(props: SocialIconProps) {
  const { icon, className } = props;
  const Icon = getSocialIconByType(icon);

  return (
    <span className={cn(s.wrapper, className)}>
      <Icon className={s.icon} />
    </span>
  );
}
